module.exports = __webpack_public_path__ + "img/lock2.e87f6233.png";